import { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PWAInstallPrompt() {
    const [deferred, setDeferred] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferred(e);
            const dismissed = localStorage.getItem('pwa_dismissed_at');
            if (!dismissed || Date.now() - parseInt(dismissed, 10) > 7 * 24 * 3600 * 1000) {
                setVisible(true);
            }
        };
        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const install = async () => {
        if (!deferred) return;
        deferred.prompt();
        const choice = await deferred.userChoice;
        if (choice.outcome !== 'dismissed') setVisible(false);
        setDeferred(null);
    };

    const dismiss = () => {
        localStorage.setItem('pwa_dismissed_at', String(Date.now()));
        setVisible(false);
    };

    if (!visible) return null;
    return (
        <div className="fixed bottom-20 lg:bottom-4 right-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-testid="pwa-install-prompt">
            <div className="bg-[hsl(var(--surface-2))] border border-border rounded-[var(--radius)] p-4 shadow-xl">
                <div className="flex items-start gap-3">
                    <div className="h-10 w-10 rounded-xl bg-[hsl(var(--primary))] grid place-items-center flex-shrink-0">
                        <Download className="h-5 w-5 text-[hsl(var(--primary-foreground))]" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="font-semibold mb-1">Instala FitHome</div>
                        <div className="text-xs text-muted-foreground mb-3">Añádela a tu pantalla de inicio para acceso rápido durante tus entrenamientos.</div>
                        <div className="flex gap-2">
                            <Button size="sm" onClick={install} data-testid="pwa-install-button">Instalar</Button>
                            <Button size="sm" variant="ghost" onClick={dismiss} data-testid="pwa-install-dismiss">Más tarde</Button>
                        </div>
                    </div>
                    <button onClick={dismiss} className="text-muted-foreground hover:text-foreground" aria-label="close">
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
